import React from "react";
import { CtaButton } from "./CtaButton";
import { images } from "../data/landing";
export function FinalCta() {
  return <section className="bg-ink px-4 py-16 sm:py-20" aria-labelledby="final-cta" data-id="element-144" data-mp="vghgnn67c9ny">
      <div className="mx-auto max-w-3xl text-center" data-id="element-145" data-mp="19f7ckzhac3aq">
        <h2 id="final-cta" className="font-display text-[38px] font-extrabold uppercase leading-[1] text-white sm:text-6xl" data-id="element-146" data-mp="19cmbwdsq3tek">
          Ready to organize your orthopedic test reference material?
        </h2>
        <p className="mt-4 text-[19px] font-bold text-gold" data-id="element-147" data-mp="1ee1wy5uwhzwy">
          Move beyond memorization. Build a more structured approach to interpretation.
        </p>
        <p className="mt-4 text-[16px] leading-relaxed text-mist" data-id="element-148" data-mp="1t2ewfct760w7">
          Get access to six organized volumes, five complementary bonuses, visual comparison tools, and educational case
          exercises — designed to help you study selected orthopedic tests, understand their limitations, and consider
          their findings within the broader clinical picture.
        </p>

        <img src={images.mockup} alt="Orthopedic Test Interpretation Blueprint collection" className="mx-auto mt-8 w-full max-w-xl" loading="lazy" data-id="element-149" data-mp="n6ntt65fkj0h" />

        <p className="mt-6 font-display text-2xl font-extrabold uppercase text-white" data-id="element-150" data-mp="s6ihz1xtmuhu">Orthopedic Test Interpretation Blueprint™</p>
        <p className="text-[14px] text-mist" data-id="element-151" data-mp="12354rw9pjvmi">By Ryan Carter</p>
        <p className="mt-3 text-[18px] font-bold text-white" data-id="element-152" data-mp="120in33t3rzqk">
          One-time payment: <span className="text-gold" data-id="element-153" data-mp="1646w7qxdv3dx">$27</span>
        </p>

        <CtaButton className="mt-6" label="Yes! Get the Blueprint™" caption="Digital product · Lifetime access · Seven-day satisfaction guarantee" data-id="element-154" data-mp="1b2ruvlwzlf09" />
      </div>
    </section>;
}